import { addVisibilityChangeListener } from 'dom-utils/lib/utils/addVisibilityChangeListener';
import { doAuthRedirect } from 'owa-service-error';
import { getScopedPath } from 'owa-url';
import { isOpx } from 'owa-opx/lib/isOpx';
import { logUsage } from 'owa-analytics';
import {
    lazyInitializeNotificationManager,
    lazyRetryDisconnectionWithMinimumReconnectInterval,
} from 'owa-notification';

// Re-connect after 10 mins of inactivity.
const RECONNECT_AFTER_TIME_IN_BACKGROUND = 10 * 60 * 1000;

export default async function initializeNotifications() {
    await lazyInitializeNotificationManager.importAndExecute({
        channelEndpoint: getScopedPath('/owa') + '/notificationchannel',
        pingInterval: 300000,
        backoffMaximum: 64000,
        minimumReconnectInterval: 1000,
        readyCheckTimeout: 60000,
        handleSessionTimeout: () => {
            // OPX uses header based auth and gets auth token via the POST messages to the OPX host layer
            // Therefore we do not need an auth redirect during session timeouts
            if (!isOpx()) {
                doAuthRedirect();
            }
            logUsage('sessionTimeout', undefined, { isCore: true });
        },
    });

    addVisibilityChangeListener(({ visibilityState, dwellTime }) => {
        if (visibilityState === 'visible' && dwellTime > RECONNECT_AFTER_TIME_IN_BACKGROUND) {
            // trigger zero delay reconnection after a buffer time for internal token refresh
            setTimeout(() => {
                lazyRetryDisconnectionWithMinimumReconnectInterval.importAndExecute();
            }, 4000);
        }
    });
}
